import * as R from 'ramda';
import * as RA from 'ramda-adjunct';
import { set } from 'lodash';

import * as types from './types';
import { contactRelationLens, artistDetailsLens, contactRelationPath, artistDetailsPath, artistFilesPath, artistFilesLens, relatedInfosLens, relatedInfosPath, relatedUsersPath, relatedCountriesPath, relatedCountriesLens, external_linksPath } from './state';
import { implementSetAllNavTabDetailsMutation } from '../../../../dt-plugins/sidewindow/nav-tab';

export const artistMutations = {
  [types.ARTISTS.SET.ALL] (state, payload) {
    state.artists = payload;
  },
  [types.ARTISTS.DELETE.SINGLE] (state, payload) {
    const { artistId } = payload;
    if (!artistId) {
      return;
    }
    state.artists = state.artists.filter(a => a.artist_id != artistId);
  },
  [types.SET_ARTIST_DETAILS] (state, value) {
    state.artistDetailsFlag = value;
  },
  [types.SET_SELECTED_ARTIST_DATA]( state, payload) {
    state.selectedArtistData = {
      ...payload
    };
  },
  [types.UPDATE_SELECTED_ARTIST_DATA]( state, payload) {
    console.log(state.selectedArtistData, payload)
    state.selectedArtistData = {
      ...state.selectedArtistData,
      ...payload
    };
  },
  [types.SET_ARTIST_CUSTOM_DATA]( state, payload) {
    console.log('SET_ARTIST_CUSTOM_DATA', payload);
    state.selectedArtistData = {
      ...state.selectedArtistData,
      customData: payload
    };
  },
  [types.RELATED_CONTACTS.SET.SINGLE] (state, payload) {
    set(state, contactRelationPath, payload);
  },
  [types.ArtistExternalLinks.SET.ALL] (state, payload) {
    set(state, external_linksPath, payload);
  },
  [types.SELECTED_ARTIST.SET.SINGLE] (state, payload) {
    set(state, artistDetailsPath, payload);
  },
  [types.ARTIST_FILES.SET.ALL] (state, payload) {
    set(state, artistFilesPath, payload);
  },
  [types.ARTIST_FILES.DELETE.SINGLE]( state, payload ) {
    const {file_id, file_relation_id } = payload;
    set(state, artistFilesPath, RA.viewOr([], artistFilesLens, state).filter(file => {
      if (file.file_id === file_id && file.file_relation_id === file_relation_id) {
        return false;
      } else {
        return true;
      }
    }));
  },
  [types.ARTIST_RELATED_INFO.DELETE.SINGLE] (state, {artistInfoId}) {
    set(state, relatedInfosPath, RA.viewOr([], relatedInfosLens, state).filter(relatedInfo => {
      if (relatedInfo.artist_info_id === artistInfoId) {
        return false;
      } else {
        return true;
      }
    })) 
  },
  [types.ARTIST_RELATED_USER.SET.ALL](state, payload) {
    set(state, relatedUsersPath, payload);
  },
  [types.ARTIST_RELATED_COUNTRIES.DELETE.SINGLE] (state, {artistCountryId}) {
    set(state, relatedCountriesPath, RA.viewOr([], relatedCountriesLens, state).filter(relatedCountry => {
      if (relatedCountry.artist_country_id === artistCountryId) {
        return false;
      } else {
        return true;
      }
    })) 
  },
  ...implementSetAllNavTabDetailsMutation(types.ArtistDetails, 'artistDetails'),
}